import React, { useMemo } from 'react';
import { TenantApiClient } from '../lib/tenant-api';
import { TenantScopeContext } from './TenantScopeContext';

interface TenantScopeProviderProps {
  tenantId: string;
  children: React.ReactNode;
}

export const TenantScopeProvider: React.FC<TenantScopeProviderProps> = ({ tenantId, children }) => {
  const tenantApi = useMemo(() => new TenantApiClient(tenantId), [tenantId]);
  return <TenantScopeContext.Provider value={tenantApi}>{children}</TenantScopeContext.Provider>;
};
